import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0 auto;\n  overflow: hidden;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0 auto;\n  overflow: hidden;\n  border-radius: inherit;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Card } from '../../Card';
import { INFO_MENU_WIDTH } from './constants';
import { isDefined } from '../../helpers/defined';
import { width } from '../../style/width';
export var InfoMenu = styled.div(_templateObject(), function (_ref) {
  var _ref$width = _ref.width,
      value = _ref$width === void 0 ? INFO_MENU_WIDTH : _ref$width;
  return isDefined(value) ? width(value) : '';
});
export var InfoMenuCard = styled(Card)(_templateObject2(), function (_ref2) {
  var _ref2$width = _ref2.width,
      value = _ref2$width === void 0 ? INFO_MENU_WIDTH : _ref2$width;
  return isDefined(value) ? width(value) : '';
});